// extracted by mini-css-extract-plugin
export default {"body":"ConfirmEmailData_body__q7+AY","title":"ConfirmEmailData_title__FX3wz","subtitle":"ConfirmEmailData_subtitle__Sv7Io"};